import { ThemeConfig } from "antd/es/config-provider/context";

export const onahAntdTheme: ThemeConfig = {
    token:{
        // global level theme
        colorPrimary:"#510845",
        fontFamily: `'Inter', 'sans-serif'`,
    },
    components:{
        // component level theme
        Input: {
            // controlOutline: 'none'
            controlOutline: 'none',
            
        },
        Select: {
            controlOutline: 'none',
            controlHeight: 50,
        },
        Checkbox: {
            colorPrimary: '#000000',
            colorPrimaryHover: '#000000'
        },
        Button: {
            controlHeight: 48,
            borderRadius: 4,
        },
        Tabs: {
            fontSize: 14,
            
        },
        Typography: {
            fontFamily: `'Inter', 'sans-serif'`
        },
        Switch: {
            colorPrimary: '#12B76A',
            controlHeight: 24,
            controlHeightLG: 26,
            colorPrimaryActive: '#12B76A',
            colorPrimaryHover: '#12B76A',
        }

    },

}